const PROVIDER_LABELS = { igloo: 'Igloo', pin: 'PIN', remotelock: 'RemoteLock', salto: 'Salto' }

export const getVisitorCreateErrorMessage = ({ t, error, isUpdate, snackbarVisitorType }) => {
  const reason = error?.response?.data?.message
  const provider = error?.response?.data?.provider

  // Note: provider-labelling activates once BE adds the machine-readable `provider` field
  // to the guest-create rejection (requested, EL-12843 W2). Until it lands, provider is
  // undefined and we return the raw-message fallback below (message-only path).
  if (provider) {
    const label = PROVIDER_LABELS[provider] || provider
    const noun =
      provider === 'pin'
        ? t('visitors:snackbar.providerNounCreation')
        : t('visitors:snackbar.providerNounKeyCreation')
    return t(
      reason ? 'visitors:snackbar.providerFailedWithReason' : 'visitors:snackbar.providerFailed',
      { label, noun, reason },
    )
  }

  if (isUpdate) {
    return reason || t('visitors:snackbar.genericError')
  }

  return reason || t('visitors:snackbar.createError', { type: snackbarVisitorType })
}
